module.exports = __webpack_public_path__ + "img/line-4.fceeac78.png";